import * as api from "../api/userService";

export async function getUser(userId) {
    const resultPage = await api
        .getUser(userId)
        return resultPage;
}

export async function createUser(request) {
    const resultPage = await api
        .createUser(request)
        return resultPage;
}

export async function updateUser(userId, request) {
    const resultPage = await api
        .updateUser(userId, request)
        return resultPage;
}

export async function getAvaliableAccounts() {
    const resultPage = await api.getAvaliableAccounts();
    return resultPage;
}

export async function switchAccount(request) {
    const resultPage = await api.switchAccount(request);
    return resultPage;
}

export async function resetPassword(request) {
    const resultPage = await api.resetPassword(request);
    return resultPage;
}

export async function verifyResetCode(request) {
    const resultPage = await api.verifyResetCode(request);
    return resultPage;
}

export async function forgotPassword(request) {
    const resultPage = await api.forgotPassword(request);
    return resultPage;
}

export async function inviteUsers(request) {
    const resultPage = await api.inviteUsers(request);
    return resultPage;
}